import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import { createStructuredSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { getCircularProgressStatus, getLinearProgressStatus } from '../../appContainer/selectors';
import { SnackbarProvider } from 'notistack';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import EntityContainerDialog from '../../views/EntityContainerDialog';

const stateSelector = createStructuredSelector({
  showLinearLoader: getLinearProgressStatus,
  showCircularLoader: getCircularProgressStatus,
});

const GlobalComponents = () => {
  const { showLinearLoader, showCircularLoader } = useSelector(stateSelector);

  return (
    <>
      {showLinearLoader ? <LinearProgress color="secondary" /> : null}
      {showCircularLoader ? <CircularProgress /> : null}
      <EntityContainerDialog />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}>
        <ErrorHandler />
      </SnackbarProvider>
    </>
  );
};

export default GlobalComponents;
